/*
 * Copyright (c) All right reserved Anvish Inc. 2025
 * This project and any portion thereof may not be reproduced or used in any manner without the express written permission of Anvish Inc.
 */
"use client";
import Image from "next/image";
import React from "react";
import { Link } from "@heroui/link";
import { AppRouterInstance } from "next/dist/shared/lib/app-router-context.shared-runtime";

interface BlogCardProps {
  blogData: {
    meta: {
      slug: string;
    };
    title: string;
    created_at: string;
    thumbnail: any;
    tags: string[];
  };
  router: AppRouterInstance;
}

const BlogCard: React.FC<BlogCardProps> = ({ blogData, router }) => {
  return (
    <Link
      className="cursor-pointer w-full h-full"
      onPress={() => router.push(`/blogs/${blogData.meta.slug}`)}
    >
      <div className="flex flex-col items-start justify-between border-1 border-[#232323]/10 gap-6 md:gap-10 w-full h-full">
        <div className="flex flex-col items-start justify-start gap-5 md:gap-6 px-6 pt-6">
          {/*<p className="text-base text-[#333]">*/}
          {/*  {new Date(blogData.created_at).toLocaleDateString("en-US", {*/}
          {/*    year: "numeric",*/}
          {/*    month: "short",*/}
          {/*    day: "numeric",*/}
          {/*  })}*/}
          {/*</p>*/}
          <p className="text-xl md:text-2xl font-medium line-clamp-3 text-ellipsis overflow-hidden text-ax-text-color">
            {blogData.title}
          </p>
          <p className="text-ax-secondary underline text text-base md:text-xl">
            Read More
          </p>
        </div>
        <Image
          alt={blogData.thumbnail.title}
          className="w-full h-auto aspect-[3/2] object-cover"
          height={230}
          src={blogData.thumbnail.meta.download_url}
          width={340}
        />
      </div>
    </Link>
  );
};

export default BlogCard;
